import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { IrrigationCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface IrrigationCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const IrrigationCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: IrrigationCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="irrigation"
      onSaveSuccess={onSaveSuccess}
    >
      <IrrigationCellDisplay value={value} />
    </TraitCellContainer>
  )
}
